<template>

</template>

<script type="text/javascript">
	export default {
		name: "Redirect",
		data() {
			return {

			}
		},
		methods: {
			alertRedirectFail() {
				this.alertFail('Invalid link')
			},
			doRedirect() {
				const vm = this

				const type = this.$route.params.type
				const slug = this.$route.params.id

				if (type == 'project')
					vm.$router.push("/project/" + slug + "/dashboard")

				else if (type == 'service')
					vm.$router.push("/service/" + slug + "/dashboard")

				else if (type == 'equipment')
					vm.$router.push("/equipment/edit/" + slug + "/log")

				else if (type == 'customer-asset')
					vm.$router.push("/contact/asset/" + slug + "/log")

				else if (type == 'user-profile')
					vm.$router.push("/profile/user/" + slug)

				else if (type == 'company-link') {

					vm.getJSON('CompanyLink/find/' + slug).then(response => {
						if (response.success) {
							window.location.href = vm.addHttp(response.data.link)
						} else {
							vm.alertRedirectFail()
						}
					})
				}
			},
			recordRedirect() {
				const vm = this

				return new Promise((resolve) => {

					const types = {
						'project':        {resource: 'Job',           key: 'job_id'},
						'service':        {resource: 'Service',       key: 'service_id'},
						'equipment':      {resource: 'Equipment',     key: 'equipment_id'},
						'customer-asset': {resource: 'CustomerAsset', key: 'customer_asset_id'},
						'user-profile':   {resource: 'User',          key: 'user_id'},
						'company-link':   {resource: 'CompanyLink',   key: 'company_link_id'},
					}

					if (!(this.$route.params.type in types))
						resolve()

					const endpoint = types[this.$route.params.type].resource + "/find/" + this.$route.params.id
					const params = {
						fields: ['id']
					}

					this.getJSON(endpoint, params).then(response => {

						if (response.success && 'id' in response.data && response.data.id) {

							let payload = {}
							payload[types[this.$route.params.type].key] = response.data.id

							vm.postData('Redirect/save', payload).then(() => {
								resolve()
							})
						} else {
							resolve()
						}
					})
				})

			}
		},
		created() {
			this.recordRedirect().then(() => {
				this.doRedirect()
			})
		}
	}
</script>
